// TODO: Clean up once we move to a component lib
// eslint-disable-next-line boundaries/element-types
import { isDevelopment } from "@av/build-constants";

export function logDevError(error: Error, info: React.ErrorInfo, boundaryName: string) {
  // Only log in development mode
  if (isDevelopment) return;

  console.log(
    `%c🚨 ${boundaryName} Triggered`,
    "color: #ff4757; font-weight: bold; font-size: 18px; background: #ffe6e6; padding: 8px 16px; border-radius: 8px; margin: 4px 0;"
  );

  console.log(
    "%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━",
    "color: #ddd;"
  );

  console.log(
    "%c⏰ Time: %c%s",
    "color: #3742fa; font-weight: bold;",
    "color: #a4b0be; font-size: 12px;",
    new Date().toLocaleString()
  );

  console.log(
    "%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━",
    "color: #ddd;"
  );

  console.log("%c💥 Error Message:", "color: #5f27cd; font-weight: bold; font-size: 16px;");
  console.log(
    "%c%s",
    "color: #c44569; font-weight: 500; font-size: 14px; padding: 4px 0;",
    error.message || "Unknown error"
  );

  console.log(
    "%c📋 Error Type: %c%s",
    "color: #3742fa; font-weight: bold;",
    "color: #c44569; font-weight: 500;",
    error.name || "Error"
  );

  if (error.stack) {
    console.log("%c🔍 Stack Trace:", "color: #5f27cd; font-weight: bold; font-size: 16px;");
    console.log(
      "%c%s",
      "color: #576574; font-family: monospace; font-size: 12px; line-height: 1.4;",
      error.stack
        .split("\n")
        .slice(1, 8)
        .map((line) => `    ${line.trim()}`)
        .join("\n")
    );
  }

  if (info.componentStack) {
    console.log("%c🧩 Component Stack:", "color: #5f27cd; font-weight: bold; font-size: 16px;");
    console.log(
      "%c%s",
      "color: #00d2d3; font-family: monospace; font-size: 12px; line-height: 1.4;",
      info.componentStack
        .split("\n")
        .filter((line) => line.trim())
        .map((line) => `    ${line.trim()}`)
        .join("\n")
    );
  }

  console.log(
    "%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━",
    "color: #ddd;"
  );

  console.log("%c💡 Development Tips:", "color: #5f27cd; font-weight: bold; font-size: 16px;");
  console.log(
    "%c• Check the component that triggered the error\n• Review recent changes in the failing component\n• Verify data types and null checks\n• Use React DevTools for component inspection",
    "color: #3742fa; font-weight: 500; line-height: 1.6; padding: 4px 0;"
  );

  console.log(
    "%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━",
    "color: #ddd;"
  );
}
